module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('button', {
    staticClass: "tw-text-white tw-ease-in-out tw-duration-200 tw-rounded tw-h-8 tw-px-2 tw-flex tw-items-center tw-cursor-pointer noselect",
    class: {
      'tw-cursor-pointer': !_vm.disabled,
      'tw-pointer-events-none': _vm.disabled,

      'tw-border tw-border-red-400 hover:tw-border-red-300': _vm.isRedColor() && !_vm.disabled,
        'tw-border tw-border-green-400 hover:tw-border-green-300': _vm.isGreenColor() && !_vm.disabled,
        'tw-border tw-border-blue-400 hover:tw-border-blue-300': _vm.isBlueColor() && !_vm.disabled,
        'tw-border tw-border-orange-400 hover:tw-border-orange-300': _vm.isOrangeColor() && !_vm.disabled,
        'tw-border tw-border-gray-400 hover:tw-border-gray-300': _vm.isGreyColor() && !_vm.disabled,
        'tw-border tw-border-teal-400 hover:tw-border-teal-300': _vm.isTealColor() && !_vm.disabled,
        'tw-border tw-border tw-border-green-inot hover:tw-border-green-inot': _vm.isTransparentAndGreenColor() && _vm.outline && !_vm.disabled,
        'tw-border tw-border tw-border-light-blue-inot hover:tw-border-light-blue-inot': _vm.isTransparentAndBlueColor() && _vm.outline && !_vm.disabled,
        'tw-border tw-border tw-border-red-700 hover:tw-border-red-700': _vm.isTransparentAndRedColor() && _vm.outline && !_vm.disabled,
        'tw-border tw-border tw-border-gray-400 hover:tw-border-gray-400': _vm.isTransparentAndGreyColor() && _vm.outline && _vm.disabled,
        'tw-border tw-border-gray-400': _vm.disabled,

        'tw-bg-red-400 hover:tw-bg-red-300 tw-text-white': _vm.isRedColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-green-400 hover:tw-bg-green-300 tw-text-white': _vm.isGreenColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-blue-400 hover:tw-bg-blue-300 tw-text-white': _vm.isBlueColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-orange-400 hover:tw-bg-orange-300 tw-text-white': _vm.isOrangeColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-gray-400 hover:tw-bg-gray-300 tw-text-white': _vm.isGreyColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-teal-400 hover:tw-bg-teal-300 tw-text-white': _vm.isTealColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-transparent-400 hover:tw-bg-transparent-300 tw-text-green-inot hover:tw-text-opacity-60': _vm.isTransparentAndGreenColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-transparent-400 hover:tw-bg-transparent-300 tw-text-light-blue-inot hover:tw-text-opacity-60': _vm.isTransparentAndBlueColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-transparent-400 hover:tw-bg-transparent-300 tw-text-red-700 hover:tw-text-opacity-60': _vm.isTransparentAndRedColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-transparent-400 hover:tw-bg-transparent-300 tw-text-gray-400 hover:tw-text-opacity-60': _vm.isTransparentAndGreyColor() && !_vm.outline && !_vm.disabled,
        'tw-bg-gray-400': _vm.disabled,

        'tw-text-red-400 hover:tw-text-white hover:tw-bg-red-400': _vm.isRedColor() && _vm.outline && !_vm.disabled,
        'tw-text-green-400 hover:tw-text-white hover:tw-bg-green-400': _vm.isGreenColor() && _vm.outline && !_vm.disabled,
        'tw-text-blue-400 hover:tw-text-white hover:tw-bg-blue-400': _vm.isBlueColor() && _vm.outline && !_vm.disabled,
        'tw-text-orange-400 hover:tw-text-white hover:tw-orange-red-400': _vm.isOrangeColor() && _vm.outline && !_vm.disabled,
        'tw-text-gray-400 hover:tw-text-white hover:tw-bg-gray-400': _vm.isGreyColor() && _vm.outline && !_vm.disabled,
        'tw-text-teal-400 hover:tw-text-white hover:tw-bg-teal-400': _vm.isTealColor() && _vm.outline && !_vm.disabled,
        'tw-text-green-inot hover:tw-text-white hover:tw-bg-green-inot': _vm.isTransparentAndGreenColor() && _vm.outline && !_vm.disabled,
        'tw-text-light-blue-inot hover:tw-text-white hover:tw-bg-light-blue-inot': _vm.isTransparentAndBlueColor() && _vm.outline && !_vm.disabled,
        'tw-text-red-700 hover:tw-text-white hover:tw-bg-red-700': _vm.isTransparentAndRedColor() && _vm.outline && !_vm.disabled,
        'tw-text-gray-400 hover:tw-text-white hover:tw-bg-gray-400': _vm.isTransparentAndGreyColor() && _vm.outline && !_vm.disabled,
        'tw-text-gray-400 hover:tw-text-white': _vm.disabled,
        'tw-rounded-full tw-w-8': _vm.circle,
        'tw-rounded': !_vm.circle,
    },
    attrs: {
      "type": _vm.isSubmit ? 'submit' : 'button',
      "title": _vm.title,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.click($event)
      }
    }
  }, [(_vm.icon !== '') ? _c('span', {
    class: [_vm.icon + ' fa-fw ', {
      'tw-text-gray-300': _vm.disabled
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.text !== '') ? _c('span', {
    staticClass: "text",
    class: {
      'tw-mx-1 tw-hidden lg:tw-block': _vm.icon,
      'tw-text-sm': _vm.textSmall,
      'tw-text-gray-300': _vm.disabled,
      'tw-underline': _vm.textUnderline,
      'tw-ml-1': _vm.icon !== ''
    }
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b2e6818"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/Button/Button.vue.html
// module id = lPhW
// module chunks = 2